import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { faTrash, faTruck, faIndustry, faMapMarked, faHotel, faFilter, faSearch } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment/moment';
//Api
import dashboard_api from '../../../api/dashboard_api';

//Components
import ModalCustomized from '../../../components/Modal/Modal';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import InfoCard from '../../../components/InfoCard/InfoCard';
import TextField from '../../../components/TextField/TextField';
import ModalidadesVeiculos from './ModalidadesVeiculos';
import ContratosPorModalidade from './ContratosPorModalidade';
import GeradoresAguardandoAprovacaoCadastro from 'views/Cadastros/Geradores/components/GeradoresAguardandoAprovacaoCadastro';

//Shared
import FiltroPrefeitura from '../../../views/Shared/FiltroPrefeitura';

//Helpers
import { showMessage } from '../../../helpers/message';
import ModalidadesCredenciamento from './ModalidadesCredenciamento';

//Context
import { useAuth } from '../../../context/auth';
import { useDashboard } from '../../../context/DashboardContext';

function initialStateFiltros() {
    const dataInicial = new Date();
    const dataFinal = new Date();
    dataInicial.setDate(dataFinal.getDate() - 30);

    return {
        dataInicial: moment(dataInicial).format("YYYY-MM-DD"),
        dataFinal: moment(dataFinal).format("YYYY-MM-DD"),
        prefeituraId: 0,
    }
}
export default function DashBoardGestao() {
    const { dadosDashboardProvider, setDadosDashboardProvider } = useDashboard();

    const { setupVariavel, setLoading } = useAuth()
    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado que guarda a modalidade selecionada para listagem dos veiculos credenciados e não credenciados
    const [modalidadeVeiculo, setModalidadeVeiculo] = useState(null);

    //Estado que guarda a modalidade selecionada para listagem dos veiculos credenciados e não credenciados
    const [modalidadeContrato, setModalidadeContrato] = useState(null);

    //Estado que guarda a modalidade selecionada para listagem dos transportadores credenciados
    const [modalidadeCredenciamento, setModalidadeCredenciamento] = useState(null);

    // Estado que guarda o status do credenciamento
    const [statusCredenciamento, setStatusCredenciamento] = useState("");

    // Estado que guarda o status do veículo
    const [statusVeiculos, setStatusVeiculos] = useState("");

    //Estado que guarda os dados da dashboard
    const [dadosDashboard, setDadosDashboard] = useState({});

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const handlePrefeitura = (value) => {
        const _filtros = {
            ...filtros,
            prefeituraId: value
        };
        setFiltros(_filtros);
        carregaDadosDashboard(_filtros);
    }

    //Estado de controle de exibição do modal
    const [openModalTop, setOpenModalTop] = useState(false);
    const [activeTop, setActiveTop] = useState(0);
    const [activeTitleTop, setActiveTitleTop] = useState("");
    const [openFiltros, setOpenFiltros] = useState(false);
    const toggleFiltros = () => setOpenFiltros(!openFiltros);

    const navigate = useNavigate();

    
    const toggleModalTop = (top = null) => {
        if (top) {
            setItemsTop(dadosDashboard[top]);
        }
        setOpenModalTop(!openModalTop);
    };

    const [openAnaliseCadastro, setOpenAnaliseCadastro] = useState(false)

    //Cabeçalhos para as tabelas de ranking
    const headersTops = [
        [
            { value: "Posição", objectValue: "posicao" },
            { value: "Ramos", objectValue: "ramoDeAtividade" },
            { value: "Volume(kg)", objectValue: "volume" },
            { value: "Quantidade", objectValue: "quantidade" }
        ],
        [
            { value: "Posição", objectValue: "posicao" },
            { value: "Geradores", objectValue: "gerador" },
            { value: "Volume(kg)", objectValue: "volume" },
            { value: "Quantidade", objectValue: "quantidade" }
        ],
        [
            { value: "Posição", objectValue: "posicao" },
            { value: "transportadores", objectValue: "transportador" },
            { value: "Volume(kg)", objectValue: "volume" },
            { value: "Quantidade", objectValue: "quantidade" }
        ],
        [
            { value: "Posição", objectValue: "posicao" },
            { value: "Destinos", objectValue: "destino" },
            { value: "Volume(kg)", objectValue: "volume" },
            { value: "Quantidade", objectValue: "quantidade" }
        ],
        [
            { value: "Posição", objectValue: "posicao" },
            { value: "Regionais", objectValue: "regional" },
            { value: "Volume(kg)", objectValue: "volume" },
            { value: "Quantidade", objectValue: "quantidade" }
        ]
    ]
    const [itemsTop, setItemsTop] = useState([]);

    //OnChange para os campos de filtros de datas
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    } 

    const carregaDadosDashboard = (_filtros = null, buttonFiltro = false) => {
        
        if(!buttonFiltro && !!dadosDashboardProvider && !!dadosDashboardProvider?.recarregarViaContext ){
            setDadosDashboard(dadosDashboardProvider);
            return;
        }  

        setLoading(true);
        if (!_filtros)
            _filtros = { ...filtros };
        if (_filtros.dataInicial.split(" ").length === 1 && _filtros.dataFinal.split(" ").length === 1) {
            _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
            _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        }
        dashboard_api.GetDashboard(_filtros).then(response => {
            setDadosDashboard(response.data);
            setDadosDashboardProvider({...response.data, recarregarViaContext: true});
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (modalidadeVeiculo) {
        return <ModalidadesVeiculos
            btnVoltar={() => setModalidadeVeiculo(null)}
            id={modalidadeVeiculo.id}
            modalidade={modalidadeVeiculo.descricao}
            statusVeiculos={statusVeiculos}
        />
    }

    if (modalidadeContrato) {
        return <ContratosPorModalidade
            prefeituraId={filtros.prefeituraId}
            btnVoltar={() => setModalidadeContrato(null)}
            id={modalidadeContrato.id}
            modalidade={modalidadeContrato.descricao}
        />
    }

    if (modalidadeCredenciamento) {
        return <ModalidadesCredenciamento
            btnVoltar={() => {
                setModalidadeCredenciamento(null);
                setStatusCredenciamento("");
            }}
            id={modalidadeCredenciamento.id}
            modalidade={modalidadeCredenciamento.descricao}
            statusCredenciamento={statusCredenciamento}
        />
    }

    if (openAnaliseCadastro) {
        return <GeradoresAguardandoAprovacaoCadastro 
                        geradoresLocalidadesPendentes={dadosDashboard?.indicadoresAguardandoAprovacaoCadastro} 
                        handleReturn={() => { setOpenAnaliseCadastro(!openAnaliseCadastro)}}
            />
    }

    return (
        <div className='ps-3 pt-3'>
            <ModalCustomized
                className={"modalCustomized"}
                isOpen={openModalTop}
                toggle={() => toggleModalTop()}
                title={activeTitleTop}
                btnClose
            >
                <TabelaListagem
                    title={activeTitleTop ? "Lista de " + activeTitleTop.split("Top 10 ")[1] : ""}
                    headers={headersTops[activeTop]}
                    items={itemsTop}
                    options={{ print: false, search: true, pagination: true }}
                />
            </ModalCustomized>
            <div className='mx-3 my-3 d-flex align-items-center justify-content-between'>
                <h3 className="text-dark fw-normal">Painel Geral</h3>
                <Button
                    onClick={toggleFiltros}
                    color='primary'
                >
                    <FontAwesomeIcon icon={faFilter} onClick={toggleFiltros} />
                    Filtros
                </Button>
            </div>
            <Row className={`filtros ${openFiltros ? "" : "close"}`}>
                <Col md="12" lg="5">
                    <TextField label={"Inicio"} type="date" value={filtros.dataInicial} name={"dataInicial"} onChange={onChangeFiltros} />
                </Col>
                <Col md="12" lg="5">
                    <TextField label={"Fim"} type="date" value={filtros.dataFinal} name={"dataFinal"} onChange={onChangeFiltros} />
                </Col>
                <Col md="12" lg="2" className='mt-4 '>
                    <Button className=' mt-2' color='info text-light' onClick={() => carregaDadosDashboard(null, true)}>
                        <FontAwesomeIcon icon={faSearch} /> Filtrar
                    </Button>
                </Col>
            </Row>
            <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
            <Row>
                <h4 className="text-dark fw-normal">Totalizadores de coleta</h4>
            </Row>
            <Row className='mb-2'>
                {dadosDashboard.totalizadoresDeColeta && dadosDashboard.totalizadoresDeColeta.map(value => {
                    return (
                        <Col lg="4" md="6" sm="12" className='mb-3'>
                            <InfoCard icon={faTrash} title={value.modalidade} subTitle="Quantidade de coletas" subTitle2={"Quantidade coletado"} thirdValue={value.volume + "Kg"} secondValue={value.quantidade} />
                        </Col>
                    )
                })}

            </Row>
            <Row >
                <h4 className="text-dark fw-normal">Top 10</h4>
            </Row>
            <Row className='mb-2'>
                <Col lg="4" md="6" sm="12" className='mb-3'>
                    <InfoCard onClick={() => {
                        setActiveTitleTop("Top 10 Ramos de atividade");
                        setActiveTop(0);
                        toggleModalTop("top10RamosDeAtividade");
                    }} icon={faTrash} title={"Top 10 Ramos de atividade"} subTitle="Clique aqui e veja mais" link={"top10"} />
                </Col>
                <Col lg="4" md="6" sm="12" className='mb-3'>
                    <InfoCard onClick={() => {
                        setActiveTitleTop("Top 10 Geradores");
                        setActiveTop(1);
                        toggleModalTop("top10Geradores");
                    }} icon={faIndustry} title={"Top 10 Geradores"} subTitle="Clique aqui e veja mais" link={"top10"} />
                </Col>
                <Col lg="4" md="6" sm="12" className='mb-3'>
                    <InfoCard onClick={() => {
                        setActiveTitleTop("Top 10 Transportadores");
                        setActiveTop(2);
                        toggleModalTop("top10Transportadores");
                    }} icon={faTruck} title={"Top 10 Transportadores"} subTitle="Clique aqui e veja mais" link={"top10"} />
                </Col>
            </Row>
            <Row className='mb-2'>
                <Col lg="4" md="6" sm="12" className='mb-3'>
                    <InfoCard onClick={() => {
                        setActiveTitleTop("Top 10 Destinos");
                        setActiveTop(3);
                        toggleModalTop("top10Destinos");
                    }} icon={faMapMarked} title={"Top 10 Destinos"} subTitle="Clique aqui e veja mais" link={"top10"} />
                </Col>
                <Col lg="4" md="6" sm="12" className='mb-3'>
                    <InfoCard onClick={() => {
                        setActiveTitleTop("Top 10 Regionais");
                        setActiveTop(4);
                        toggleModalTop("top10Regionais");
                    }} icon={faHotel} title={"Top 10 Regionais"} subTitle="Clique aqui e veja mais" link={"top10"} />
                </Col>
            </Row>

            <Row >
                <h4 className="text-dark fw-normal">Contratos</h4>
            </Row>
            <Row className='mb-2'>
                <Col lg="4" md="6" sm="12" className='mb-3'>
                    <InfoCard
                        onClick={() => navigate("../geradores/contratos", { state: { option: "Com contrato"  } })}
                        icon={faIndustry} title={"Geradores com contrato firmado"}
                        specialSubTitle={dadosDashboard.geradoresComContrato}
                        link={"contratos"}
                    />
                </Col>
                <Col lg="4" md="6" sm="12" className='mb-3'>
                    <InfoCard
                        onClick={() => navigate("../geradores/contratos", { state: { option: "Sem contrato" } })}
                        icon={faIndustry}
                        title={"Geradores sem contrato firmado"}
                        specialSubTitle={dadosDashboard.geradoresSemContrato}
                        link={"contratos"}
                    />
                </Col>
                <Col lg="4" md="6" sm="12" className='mb-3'>
                    <InfoCard
                        onClick={() => navigate("../geradores/contratos", { state: { option: "Contrato Pendente" } })}
                        icon={faIndustry}
                        title={"Geradores com Contratos Pendentes"}
                        specialSubTitle={dadosDashboard.geradoresComContratoPendente}
                        link={"contratos"}
                    />
                </Col>
            </Row>

            {setupVariavel?.analisePGRS == true &&
                dadosDashboard?.indicadoresPGRS &&
                <>
                    <Row >
                        <h4 className="text-dark fw-normal">PGRS</h4>
                    </Row>
                    <Row className='mb-2'>
                        <Col lg="4" md="6" sm="12" className='mb-3'>
                            <InfoCard
                                onClick={() => navigate("/admin/pgrs")}
                                icon={faIndustry}
                                title={"PGRS Aguardando Análise"}
                                specialSubTitle={dadosDashboard.indicadoresPGRS.totalEmAnalisePGRS == 0 ? "0" : dadosDashboard.indicadoresPGRS.totalEmAnalisePGRS}
                                link={"PGRS"}
                            />
                        </Col>

                        <Col lg="4" md="6" sm="12" className='mb-3'>
                            <InfoCard
                                onClick={() => navigate("/admin/geradoresSemPGRS")}
                                icon={faIndustry}
                                title={"Geradores sem PGRS"}
                                specialSubTitle={dadosDashboard.indicadoresPGRS.totalizadoresGeradoresSemPGRS == 0 ? "0" : dadosDashboard.indicadoresPGRS.totalizadoresGeradoresSemPGRS}
                                link={"PGRS"}
                            />
                        </Col>
                    </Row>
                </>
            }

            {setupVariavel?.requerAnaliseGeradorLocalidade == true &&
                <>
                    <Row >
                        <h4 className="text-dark fw-normal">Aprovação de Cadastro</h4>
                    </Row>
                    <Row className='mb-2'>
                        <Col lg="4" md="6" sm="12" className='mb-3'>
                            <InfoCard
                                onClick={() => setOpenAnaliseCadastro(true)}
                                icon={faIndustry}
                                title={"Geradores Aguardando Aprovação de Cadastro"}
                                specialSubTitle={dadosDashboard?.indicadoresAguardandoAprovacaoCadastro?.length}
                                link={"PGRS"}
                            />
                        </Col>
                    </Row>
                </>
            }

            <Row >
                <h4 className="text-dark fw-normal">Credenciamentos por modalidade</h4>
            </Row>
            <Row className='mb-2'>
                {dadosDashboard.credenciamentoTransportadoresModalidades && dadosDashboard.credenciamentoTransportadoresModalidades.map(value => {
                    return (
                        <Col lg="4" md="6" sm="12" className='mb-3'>
                            <InfoCard className='h-100 w-100' icon={faTruck} title={value.descricao}
                                CustomizedSubtitles={
                                    () => (
                                        <>
                                            <div
                                                onClick={() => {
                                                    setModalidadeCredenciamento(value);
                                                    setStatusCredenciamento("quantidade transportadores");
                                                }}
                                                className="d-flex align-items-center justify-content-between mb-2 mt-2 linkInfo rounded-3"
                                            >
                                                <span>Quantidade de Transportadores</span>
                                                <span className="fw-bold">{value.qtdTransportadores}</span>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    setModalidadeCredenciamento(value);
                                                    setStatusCredenciamento("Contratos");
                                                }}
                                                className="d-flex align-items-center justify-content-between mb-2 mt-2 linkInfo rounded-3"
                                            >
                                                <span>Quantidade de Contratos</span>
                                                <span className="fw-bold">{value.qtdContratos}</span>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    setModalidadeCredenciamento(value);
                                                    setStatusCredenciamento("Em dia");
                                                }}
                                                className="d-flex align-items-center justify-content-between mb-2 mt-2 linkInfo rounded-3"
                                            >
                                                <span>Credenciamentos em dia</span>
                                                <span className="fw-bold">{value.qtdCredenciamentosDia}</span>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    setModalidadeCredenciamento(value);
                                                    setStatusCredenciamento("A vencer");
                                                }}
                                                className="d-flex align-items-center justify-content-between mb-2 mt-2 linkInfo rounded-3"
                                            >
                                                <span>Credenciamentos a vencer</span>
                                                <span className="fw-bold">{value.qtdCredenciamentosVencer}</span>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    setModalidadeCredenciamento(value);
                                                    setStatusCredenciamento("Vencido");
                                                }}
                                                className="d-flex align-items-center justify-content-between mb-2 mt-2 linkInfo rounded-3"
                                            >
                                                <span>Credenciamentos vencidos</span>
                                                <span className="fw-bold">{value.qtdCredenciamentosVencidos}</span>
                                            </div>
                                        </>
                                    )
                                }
                            />
                        </Col>
                    );
                })}
            </Row>
            <Row>
                <h4 className="text-dark fw-normal">Total de veículos e contratos por modalidade</h4>
            </Row>
            <Row className='mb-2'>
                {dadosDashboard.veiculosPorModalidadeEContratos && dadosDashboard.veiculosPorModalidadeEContratos.map(value => {
                    return (
                        <Col lg="4" md="6" sm="12" className='mb-3'>
                            <InfoCard className='h-100 w-100' icon={faTruck} title={value.descricao}
                                CustomizedSubtitles={
                                    () => (
                                        <>
                                            <div onClick={() => setModalidadeContrato(value)} className="d-flex align-items-center justify-content-between mb-2 mt-2 linkInfo rounded-3">
                                                <span>Contratos</span>
                                                <span className="fw-bold">{value.quantidadeContratos}</span>
                                            </div>
                                            <div onClick={() => { setModalidadeVeiculo(value); setStatusVeiculos("Em dia") }} className="d-flex align-items-center justify-content-between mb-2 linkInfo rounded-3">
                                                <span>Credenciamento em dia</span>
                                                <span className="fw-bold">{value.quantidadeEmDia}</span>
                                            </div>
                                            <div onClick={() => { setModalidadeVeiculo(value); setStatusVeiculos("Vencido") }} className="d-flex align-items-center justify-content-between mb-2 linkInfo rounded-3">
                                                <span>Credenciamento vencido</span>
                                                <span className="fw-bold">{value.quantidadeVencido}</span>
                                            </div>
                                        </>
                                    )
                                }
                            />
                        </Col>
                    );
                })}
            </Row>
        </div >
    )
}